import { CheckCircle2, Clock } from "lucide-react";

/**
 * ReflectedToggle — "¿El pago ya está reflejado en tu cuenta?" two-state
 * selector used when registering an abono or liquidating with a promo.
 */
export const ReflectedToggle = ({ value, onChange, idPrefix = "reflected" }) => (
  <div data-testid={`${idPrefix}-toggle`}>
    <div className="text-[10px] uppercase tracking-widest text-neutral-300 mb-1.5">Estado del pago</div>
    <div className="grid grid-cols-2 gap-2">
      <button
        type="button"
        data-testid={`${idPrefix}-yes`}
        onClick={() => onChange(true)}
        className={`flex items-center justify-center gap-1.5 rounded-lg border px-3 py-2 text-xs font-semibold transition ${value ? "border-emerald-400 bg-emerald-500/20 text-emerald-200" : "border-white/10 bg-black/40 text-neutral-400 hover:border-emerald-500/40"}`}
      >
        <CheckCircle2 className="w-3.5 h-3.5" /> Ya reflejado
      </button>
      <button
        type="button"
        data-testid={`${idPrefix}-no`}
        onClick={() => onChange(false)}
        className={`flex items-center justify-center gap-1.5 rounded-lg border px-3 py-2 text-xs font-semibold transition ${!value ? "border-amber-400 bg-amber-500/20 text-amber-200" : "border-white/10 bg-black/40 text-neutral-400 hover:border-amber-500/40"}`}
      >
        <Clock className="w-3.5 h-3.5" /> Aún no reflejado
      </button>
    </div>
    <p className="text-[10px] text-neutral-500 mt-1">
      {value
        ? "Se indicará al cliente que el pago ya está reflejado en tu cuenta."
        : "Se indicará al cliente que el pago aún no se refleja. Podrás marcarlo como reflejado después y avisarle."}
    </p>
  </div>
);

export default ReflectedToggle;
